import React from "react";
import { TextLink } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { usePersonTitles } from "../hooks/usePersonTitles";
import { formatPersonTitleRoles, getTitleDetailPath, } from "./PersonTitlesSection";
import styles from "./PersonTitlesPreview.module.css";
/** How many titles of a person the preview lists before "a další N". */
export var MAX_PREVIEW_TITLES = 3;
/**
 * Short list of the titles a person appears in (backend order = by title name),
 * so that namesakes can be told apart, e.g. in the "Sloučit duplicity" dialog
 * (DB-681). Each title links to its detail in a new tab and shows the person's
 * roles there. A loading failure is shown in place and blocks nothing.
 */
export var PersonTitlesPreview = function (_a) {
    var kind = _a.kind, personId = _a.personId;
    var _b = usePersonTitles(kind, personId), _c = _b.data, titles = _c === void 0 ? [] : _c, isLoading = _b.isLoading, isError = _b.isError;
    var renderContent = function () {
        if (isLoading) {
            return React.createElement(FormattedMessage, { id: "ui-br-agency.loading" });
        }
        if (isError) {
            return (React.createElement("span", { className: styles.titleError },
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.titles.error" })));
        }
        if (titles.length === 0) {
            return (React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.titles.empty" }));
        }
        var hidden = titles.length - MAX_PREVIEW_TITLES;
        return (React.createElement("ul", { className: styles.titleList },
            titles.slice(0, MAX_PREVIEW_TITLES).map(function (title) {
                var roles = formatPersonTitleRoles(title);
                return (React.createElement("li", { key: title.titleId },
                    React.createElement(TextLink, { href: getTitleDetailPath(title.titleId), target: "_blank", rel: "noopener noreferrer" }, title.titleName || title.titleId),
                    roles && " (".concat(roles, ")")));
            }),
            hidden > 0 && (React.createElement("li", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.titles.more", values: { count: hidden } })))));
    };
    return React.createElement("div", { className: styles.titles }, renderContent());
};
